import getSpamScenarioStore from '../selectors/getSpamScenarioStore';
import { SpamScenarioId } from 'owa-junkmail-configuration';
import { getMailboxJunkEmailListByScenarioId } from 'owa-junkmail-configuration';

const arrayEquals = require('array-equal');

export default function isSpamOptionDirty(scenarioId: SpamScenarioId) {
    const optionState = getSpamScenarioStore(scenarioId);
    const spamList = getMailboxJunkEmailListByScenarioId(scenarioId);

    if (optionState.spamList) {
        return !arrayEquals(optionState.spamList, spamList);
    }
    return false;
}
